import { useMemo } from "react";
import { useCartActions } from "./useCartActions";
import { useUIStore } from "../store";
import { useNavigate, useSearchParams } from "react-router-dom";

export const useTotalCart = (orders: any[], total: number) => {
  const { sendOrderToWhatsApp } = useCartActions();
  const setSection = useUIStore((s) => s.setSection);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const totalItems = useMemo(
    () => orders.reduce((acc, item) => acc + item.quantity, 0),
    [orders]
  );

  const openCart = () => {
    // conservar branding del local
    const name = searchParams.get("name");
    const color = searchParams.get("color");

    const params = new URLSearchParams();
    if (name) params.set("name", name);
    if (color) params.set("color", color);

    // opcional: si querés también conservar producto/título/precio cuando estés en promo
    const product = searchParams.get("product");
    const title = searchParams.get("title");
    const price = searchParams.get("price");

    if (product) params.set("product", product);
    if (title) params.set("title", title);
    if (price) params.set("price", price);

    setSection("cart");
    navigate(
      {
        pathname: window.location.pathname,
        search: params.toString() ? `?${params.toString()}` : "",
      },
      { replace: false }
    );
  };

  return {
    total,
    totalItems,
    handleSendWhatsApp: () => sendOrderToWhatsApp(orders, total),
    openCart,
  };
};